import React from "react";
import { Row, Col } from 'reactstrap';
import { useForm } from "react-hook-form";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // optional
import CurrencyInput from 'react-currency-input-field';

const Step10Alt = (props) => {

  const {
    formRef,
    onSubmit,
    prices,
    viewMode
  } = props

  const { register, handleSubmit } = useForm();

  return (

    <form onSubmit={handleSubmit(onSubmit)} id="step10Alt" ref={formRef} className="mb-4">
      <h4>10.1 Bordereau de prix unitaires</h4>

      <Col>
        {viewMode !== true && <button type="submit" className="btn-green mt-3" >
            Sauvegarder
        </button>}
        <br/>
      </Col>


      <div className="sticky d-flex align-items-center">
        <Col xs="12" sm="1">Ref</Col>
        <Col xs="12" sm="5">Article</Col>
        <Col xs="12" sm="1">Seuil A</Col>
        <Col xs="12" sm="1">Seuil B</Col>
        <Col xs="12" sm="1">Unité</Col>
        <Col xs="12" sm="1">Prix par unité pour des unités inférieures au seuil A</Col>
        <Col xs="12" sm="1">Prix par unité pour des unités comprises entre les seuils A et B</Col>
        <Col xs="12" sm="1">Prix par unité pour des unités supérieures au seuil B</Col>
      </div>

      {prices?.map((price, index) => (
        <span key={index}>
          <input type="hidden" name={`prices.${index}.articlePriceId`} value={price.id}
          {...register(`prices.${index}.articlePriceId`, {
            required: true,
          })}
          />
          <input type="hidden" name={`prices.${index}.articleId`} value={price.article.id}
          {...register(`prices.${index}.articleId`, {
            required: true,
          })}
          />
          <Row noGutters key={index} className="align-middle article">
            <Col xs="12" sm="1" className="pl-2 my-auto">
              <p>{price.article.code}</p>
            </Col>
            <Col xs="12" sm="5" className="my-auto">
              <Tippy content={price.article.name}><p>{price.article.name}</p></Tippy>
            </Col>
            <Col xs="12" sm="1" className="my-auto">
              <p>{price.article.quantityB}</p>
            </Col>
            <Col xs="12" sm="1" className="my-auto">
              <p>{price.article.quantityC}</p>
            </Col>
            <Col xs="12" sm="1" className="my-auto">
              <p>{price.article.unit}</p>
            </Col>
            <Col xs="12" sm="1">
              <div className="mr-sm-1 mx-sm-1 form-group my-1">
                <CurrencyInput
                  name={`prices.${index}.priceA`}
                  autoComplete="off"
                  placeholder="En €"
                  className="form-control"
                  decimalsLimit={2}
                  allowNegativeValue={false}
                  disableGroupSeparators={true}
                  defaultValue={price.priceA ? price.priceA / 100 : ''}
                  {...register(`prices.${index}.priceA`, {
                    required: false,
                  })}
                />
              </div>
            </Col>
            <Col xs="12" sm="1">
              <div className="mr-sm-1 mx-sm-1 form-group my-1">
                <CurrencyInput
                  name={`prices.${index}.priceB`}
                  autoComplete="off"
                  placeholder="En €"
                  defaultValue={price.priceB ? price.priceB / 100 : ''}
                  className="form-control"
                  decimalsLimit={2}
                  allowNegativeValue={false}
                  disableGroupSeparators={true}
                  {...register(`prices.${index}.priceB`, {
                    required: false,
                  })}
                />
              </div>
            </Col>
            <Col xs="12" sm="1">
              <div className="mr-sm-1 mx-sm-1 form-group my-1">
                <CurrencyInput
                  name={`prices.${index}.priceC`}
                  autoComplete="off"
                  placeholder="En €"
                  className="form-control"
                  decimalsLimit={2}
                  allowNegativeValue={false}
                  disableGroupSeparators={true}
                  defaultValue={price.priceC ? price.priceC / 100 : ''}
                  {...register(`prices.${index}.priceC`, {
                    required: false,
                  })}
                />

              </div>
            </Col>
          </Row>
          <hr/>
        </span>
      ))
      }
      {viewMode !== true && <button type="submit" className="btn-green mt-3" >
          Sauvegarder
      </button>}
    </form>
  );

};

Step10Alt.propTypes = {
};

Step10Alt.defaultProps = {

};

export default Step10Alt;
